if (!customElements.get('frd-filter-actions')) {
  customElements.define('frd-filter-actions', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.facets = this.closest('.facets');
      if (!this.button || !this.facets) return;
      this.onClick = () => this.facets.querySelector('.facets__mobile-close')?.click();
      this.syncLabel = () => {
        const label = this.facets.querySelector('[data-frd-results-label]');
        if (label) this.button.textContent = label.textContent;
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.syncLabel);
      const active = this.facets.querySelector('.facets__active');
      if (active) this.observer.observe(active, {childList:true, subtree:true});
      this.syncLabel();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
